import React, { useContext, useEffect, useState, useRef } from 'react'
import { toast } from 'react-toastify'
import { BASE_URL_API } from '../../References/urls'
import AuthContext from '../../Store/auth-context'
import styles from './ELPDSQrs.module.css'




import domtoimage from 'dom-to-image';
import { saveAs } from 'file-saver';
import QRCode from 'react-qr-code';
import JSZip from 'jszip';

import html2canvas from 'html2canvas';
import EachCodeRow from '../QRCode/EachCodeRow'
import QRCodeRenderer from '../QRCode/QRCodeRenderer'




const ELPDSQrs = ({ pdsCampaignIdentifier }) => {
    const [isFetchingData, setIsFetchingData] = useState(false)
    const authCtx = useContext(AuthContext)
    const [codeQuantity, setCodeQuantity] = useState('')
    const [isGenerating, setIsGenerating] = useState(false)

    const [form, setForm] = useState({
        campaignName: '',
        budget: '',
        expectedUsers: '',
        campaignStartDate: '',
        campaignEndDate: '',
        bigWinnersCount: '',
        bigWinnerMin: '',
        bigWinnerMax: '',
        bigWinnersRandom: true,
        maxScansPerUser: '',
        maxRewardPerUser: '',
        scanRewardCap: true,
        strictBudgetEnforcement: true,
        enableStreakBonus: false,
        enableJackpotScan: false,
        bonusEveryNthScan: '',
        spinToWinEnabled: false,
        testMode: false,
        loggingEnabled: true,
        scanRewardTiers: [{ scan: 1, min: '', max: '' }],
        bigWinAtScan: '', // <-- NEW
    })


    const getBoosterPdsConfig = async () => {
        setIsFetchingData(true)
        const response = await fetch(BASE_URL_API + "/getBoosterPdsConfig",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    campaignIdentifier: pdsCampaignIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                const data = respo?.response;
                // ✅ Fix: Parse scanRewardTiers if it's a string
                if (typeof data.scanRewardTiers === "string") {
                    try {
                        data.scanRewardTiers = JSON.parse(data.scanRewardTiers);
                    } catch (err) {
                        console.error("Failed to parse scanRewardTiers", err);
                        data.scanRewardTiers = [];
                    }
                }

                setForm(data);
                console.log(data);
            } else {
                if (respo?.message === "token Expired, please login again!") {
                    authCtx.logout()
                }
            }
        }
        setIsFetchingData(false)
    }

    useEffect(() => {
        getBoosterPdsConfig()
    }, [pdsCampaignIdentifier])

    const generateQRCodesHandler = async () => {
        if (codeQuantity !== 0) {
            setIsGenerating(true)
            const generateQRCodesResponse = await fetch(BASE_URL_API + "/generateBoosterQrCodes",
                {
                    method: "POST",
                    body: JSON.stringify({
                        token: authCtx.token,
                        codeQuantity: codeQuantity,
                        campaignIdentifier: pdsCampaignIdentifier,
                        subdomain: 'app'
                    })
                })

            if (!generateQRCodesResponse.ok) {
                console.log("Something went wrong : Server Error")
            } else {
                const generateQRCodesRespo = await generateQRCodesResponse.json()
                if (generateQRCodesRespo.status === "success") {
                    toast(`Successfully generated the qr codes!`)
                    getGeneratedQRCodes()
                } else {
                    if (generateQRCodesRespo.message === "token Expired, please login again!") {
                        authCtx.logout()
                    } else {
                        alert(generateQRCodesRespo.message)
                    }
                }
                console.log(generateQRCodesRespo)
            }
            setIsGenerating(false)
        } else {
            console.log(codeQuantity)
            alert("Please select quantity of codes to be generated!")
        }
    }


    //// this is qr code section 

    const [codesData, setCodesData] = useState([])
    const [selectedCodes, setSelectedCodes] = useState([])
    const [fetchingFilter, setFetchingFilter] = useState('ALL'); // UNSCANNED
    const [isGettingQRs, setIsGettingQRs] = useState(false)
    const selectionHandler = (k) => {
        if (selectedCodes.includes(k)) {
            setSelectedCodes(
                selectedCodes.filter((item) => item !== k)
            )
        } else {
            setSelectedCodes([...selectedCodes, k])
        }
    }

    const getGeneratedQRCodes = async () => {
        setIsGettingQRs(true)
        const getGeneratedQRCodesResponse = await fetch(BASE_URL_API + "/getGeneratedBoosterQRCodes",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    fetchingFilter: fetchingFilter
                })
            });

        if (!getGeneratedQRCodesResponse.ok) {
            console.log("Something went wrong : Server Error ")
        } else {
            const getGeneratedQRCodesRespo = await getGeneratedQRCodesResponse.json()
            if (getGeneratedQRCodesRespo.status === "success") {
                setCodesData(getGeneratedQRCodesRespo.response)
            } else {
                if (getGeneratedQRCodesRespo.message === "token Expired, please login again!") {
                    authCtx.logout()
                } else {
                    setCodesData([])
                }
            }

        }
        setIsGettingQRs(false)
    }

    useEffect(() => {
        getGeneratedQRCodes()
    }, [fetchingFilter])


    const multipleSelectionHandler = (k) => {
        // make current selection zero.. 
        let tempSelected = selectedCodes
        tempSelected = []
        let copiedCodes = codesData.slice(0, k)
        setSelectedCodes(copiedCodes.map(item => item?.codeIdentifier))
    }


    const downloadQRCodeInBulk = () => {
        selectedCodes?.forEach((item, index) => {
            const node = document.getElementById(`${item}-qr-code`);

            // Set desired scale (e.g., 3x for better resolution)
            const scale = 3;

            const style = {
                transform: 'scale(' + scale + ')',
                transformOrigin: 'top left',
                width: node.offsetWidth + "px",
                height: node.offsetHeight + "px"
            };

            const param = {
                width: node.offsetWidth * scale,
                height: node.offsetHeight * scale,
                style: style
            };

            domtoimage.toBlob(node, param)
                .then(function (blob) {
                    saveAs(blob, `${item}.png`);
                })
                .catch(function (error) {
                    console.error('oops, something went wrong!', error);
                });
        });
    };




    const downloadBulkQRCodeInZip = () => {
        const zip = new JSZip();
        const promises = [];


        selectedCodes?.forEach((item, index) => {
            console.log("jhghg", item)
            // Define a promise for each QR code generation
            const promise = new Promise((resolve) => {
                // Define onQRCodeGenerated function
                const onQRCodeGenerated = (blob) => {
                    console.log(`QR code ${item} generated. Blob size: ${blob.size}`);
                    zip.file(`${item}-qr-code.png`, blob);
                    resolve(); // Resolve the promise when QR code is generated
                };

                // Render the QRCodeRenderer component
                <QRCodeRenderer key={index} value={item} onQRCodeGenerated={onQRCodeGenerated} />;
            });

            // Push the promise to the array
            promises.push(promise);

            console.log("Promise status : ", promise)
        });

        // Wait for all promises to resolve
        Promise.all(promises).then(() => {
            console.log("All QR codes generated. Total files to be added to zip:", Object.keys(zip.files).length);
            // Generate zip file and initiate download
            zip.generateAsync({ type: 'blob' }).then(function (blob) {
                console.log("Zip file generated. Blob size:", blob.size);
                saveAs(blob, 'bulk_qrcodes.zip');
            });
        });
    };



    return (
        <div>
            <div>
                <div className={styles.titleWrapper}>
                    <div className={styles.qrTagline}>
                        This booster campaign requires {form?.expectedUsers * form?.maxScansPerUser} Qr codes to be generated minimum.
                        (Total Expected User : {form?.expectedUsers})x(Maximum Scans Per User : {form?.maxScansPerUser})
                    </div>
                    <div className={styles.generateText}>
                        Generate
                        <input value={codeQuantity}
                            onChange={(e) => setCodeQuantity(e.target.value)}
                            type="number"
                        />
                        Qr Code(s)
                        <button onClick={() => generateQRCodesHandler()} >Generate Now</button>
                    </div>
                </div>

            </div>


            {/* this is view qr codes option  */}
            <div>
                <div>
                    {/* <div className={styles.titleWrapper}>
                        <div>
                            <button onClick={() => setFetchingFilter("ALL")} >Fetch All Codes</button>
                            <button onClick={() => setFetchingFilter("UNSCANNED")} >Fetch Unscanned Codes</button>
                        </div>
                    </div> */}
                    <div className={styles.actionHeaderWrapper}>
                        <div className={styles.selectBulkOptionsWrapper}>
                            <button onClick={() => multipleSelectionHandler(10)}>Select 10 Codes</button>
                            <button onClick={() => multipleSelectionHandler(20)}>Select 20 Codes</button>
                            <button onClick={() => multipleSelectionHandler(50)}>Select 50 Codes</button>
                            <button onClick={() => multipleSelectionHandler(100)}>Select 100 Codes</button>
                        </div>
                        <div className={styles.downloadActionWrapper}>
                            <div>
                                {selectedCodes.length} / {codesData.length}
                            </div>
                            {selectedCodes?.length>0 &&
                            <div className={styles.downloadBtnWrapper}>
                                <button onClick={() => downloadQRCodeInBulk()} >Download</button>
                                {/* <button onClick={() => downloadBulkQRCodeInZip()} >Download In Zip</button> */}
                            </div>
                            }
                        </div>
                    </div>
                </div>
                {isGettingQRs === true ?
                    <div className={styles.naWrapper}>
                        Hold On!
                        Collecting QRs Data...
                    </div>
                    :
                    <div>
                        {codesData?.length > 0 ?
                            <div>
                                <div className={styles.tableHeader}>
                                    <div className={styles.sn}>#</div>
                                    <div className={styles.sn}>-</div>
                                    <div className={styles.codeWrapper}>View & Download</div>
                                    <div className={styles.mappedWithProduct}>Map With Product</div>
                                    <div className={styles.hasScanned}>Has Scanned?</div>
                                    <div className={styles.scannedOn}>Scanned On</div>
                                    <div className={styles.actionWrapper}>Action</div>
                                </div>
                                <div className={styles.tableWrapper}>
                                    {codesData?.map((item, index) => (
                                        <EachCodeRow key={index} isSelected={selectedCodes.includes(item?.codeIdentifier)} selectionHandler={selectionHandler} count={index} item={item} />
                                    ))}
                                </div>
                            </div>
                            :
                            <div className={styles.naWrapper}>
                                No QR code available!
                            </div>
                        }
                    </div>
                }


            </div>
        </div>
    )
}

export default ELPDSQrs